import { useMutation } from '@apollo/react-hooks'
import {
  DeleteMarketplaceListingMutation,
  DeleteMarketplaceListingMutationVariables
} from './__generated__/DeleteMarketplaceListingMutation'
import { gql } from 'apollo-boost'
import {
  DeleteMarketplaceListingPropsMutation,
  DeleteMarketplaceListingPropsMutationVariables
} from './__generated__/DeleteMarketplaceListingPropsMutation'

const DELETE_MARKETPLACE_LISTING = gql`
  mutation DeleteMarketplaceListingMutation($id: String!) {
    deleteMarketplaceListing(input: { marketplaceListingId: $id }) {
      id
      deleted
    }
  }
`

const DELETE_MARKETPLACE_LISTING_PROPS_MUTATION = gql`
  mutation DeleteMarketplaceListingPropsMutation($marketplaceListingId: String!) {
    deleteMarketplaceListingPropsV2(input: { marketplaceListingId: $marketplaceListingId }) {
      ... on MarketplaceListingPropsV2 {
        marketplaceListingId
        propsJson
      }
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
    }
  }
`
export const useDeleteMarketplaceListing = () =>
  useMutation<DeleteMarketplaceListingMutation, DeleteMarketplaceListingMutationVariables>(DELETE_MARKETPLACE_LISTING)

export const useDeleteMarketplaceListingProps = () =>
  useMutation<DeleteMarketplaceListingPropsMutation, DeleteMarketplaceListingPropsMutationVariables>(
    DELETE_MARKETPLACE_LISTING_PROPS_MUTATION
  )
